import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'inerva_cookies_accepted';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 max-w-xs">
      <div className="bg-[var(--color-inerva-forest)] text-white rounded-lg shadow-md px-4 py-3">
        <p className="text-xs leading-relaxed mb-2">
          Usamos cookies para mejorar tu experiencia.{' '}
          <Link to="/cookies" className="text-white underline hover:no-underline">
            Más info
          </Link>
        </p>
        <button
          onClick={accept}
          className="w-full bg-white text-[var(--color-inerva-forest)] text-xs font-medium px-3 py-1.5 rounded hover:bg-[var(--color-inerva-cream)] transition-colors"
        >
          Aceptar
        </button>
      </div>
    </div>
  );
}
